<template>
    <div class="video-player">
        <vue-plyr ref="plyr">
            <div data-plyr-provider="vimeo" :data-plyr-embed-id="vimeo_source"></div>
        </vue-plyr>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    props: ['source'],

    data() {
        return {
            vimeo_source: null
        }
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token'
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        player () { return this.$refs.plyr.player }
    },

    methods: {
        vimeoParser(url){
            console.log(url)
            let regExp = /^.*(vimeo\.com\/)((channels\/[A-z]+\/)|(groups\/[A-z]+\/videos\/))?([0-9]+)/
            let match = url.match(regExp)
            this.vimeo_source = match[5]
        }
    },

    created() {
        this.vimeoParser(this.source)
    }
}
</script>

<style lang="stylus" scoped>

</style>
